import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import Button from '../Button';
import Grid from '../Grid';
import { ArrowLeftIcon } from '../icons/ArrowLeftIcon';
import { CancelBkgIcon } from '../icons/CancelBkgIcon';
import Typography from '../Typography';
import { StyledBackButtonWrapper, StyledCloseButton, StyledContentBox, StyledHeaderRow, StyledPopUp, StyledPopUpBackdrop } from './styles';
import { type PopupProps } from './types';
const PopUp = forwardRef<HTMLDivElement, PopupProps>((t0, ref) => {
  const $ = _c(43);
  let backButtonText;
  let children;
  let handleOpen;
  let onBack;
  let props;
  let subTitle;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    ({
      handleOpen,
      open: t1,
      children,
      title,
      subTitle,
      cancelText: t2,
      compact: t3,
      onBack,
      backButtonText,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backButtonText;
    $[2] = children;
    $[3] = handleOpen;
    $[4] = onBack;
    $[5] = props;
    $[6] = subTitle;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = title;
  } else {
    backButtonText = $[1];
    children = $[2];
    handleOpen = $[3];
    onBack = $[4];
    props = $[5];
    subTitle = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    title = $[10];
  }
  const open = t1 === undefined ? false : t1;
  const cancelText = t2 === undefined ? "Cancel" : t2;
  const compact = t3 === undefined ? false : t3;
  let t4;
  if ($[11] !== handleOpen) {
    t4 = (e, reason) => {
      const mouseEvent = e as React.MouseEvent<HTMLButtonElement>;
      handleOpen(mouseEvent, reason);
    };
    $[11] = handleOpen;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== backButtonText || $[14] !== onBack) {
    t5 = onBack != null && <StyledBackButtonWrapper><Button onClick={onBack} variant="text" leftIcon={<ArrowLeftIcon />}>{backButtonText ?? ""}</Button></StyledBackButtonWrapper>;
    $[13] = backButtonText;
    $[14] = onBack;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== title) {
    t6 = title == null || typeof title === "string" ? <Typography variant="h2">{title === undefined ? "" : title}</Typography> : title;
    $[16] = title;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <Grid xs={true} minWidth={0}>{t6}</Grid>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CancelBkgIcon />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== handleOpen) {
    t9 = e_0 => {
      handleOpen(e_0, "closeButtonClick");
    };
    $[21] = handleOpen;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== cancelText || $[24] !== t9) {
    t10 = <StyledCloseButton rightIcon={t8} onClick={t9} scheme="light" variant="text">{cancelText}</StyledCloseButton>;
    $[23] = cancelText;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t5 || $[28] !== t7) {
    t11 = <StyledHeaderRow>{t5}{t7}{t10}</StyledHeaderRow>;
    $[26] = t10;
    $[27] = t5;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = subTitle != null && subTitle;
  let t13;
  if ($[30] !== children) {
    t13 = <StyledContentBox>{children}</StyledContentBox>;
    $[30] = children;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== compact || $[33] !== t11 || $[34] !== t12 || $[35] !== t13) {
    t14 = <StyledPopUp $compact={compact}>{t11}{t12}{t13}</StyledPopUp>;
    $[32] = compact;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== open || $[38] !== props || $[39] !== ref || $[40] !== t14 || $[41] !== t4) {
    t15 = <StyledPopUpBackdrop open={open} {...props} ref={ref} onClose={t4}>{t14}</StyledPopUpBackdrop>;
    $[37] = open;
    $[38] = props;
    $[39] = ref;
    $[40] = t14;
    $[41] = t4;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
});
export default PopUp;
export { PopUp };